/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargePointVolumeFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ChargePointVolume, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/volume
 */
export interface VolumeRequestBuilder extends BaseRequestBuilder<VolumeRequestBuilder> {
    /**
     * GetChargePointVolume
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargePointVolume>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<VolumeRequestBuilderGetQueryParameters> | undefined) : Promise<ChargePointVolume | undefined>;
    /**
     * GetChargePointVolume
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<VolumeRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetChargePointVolume
 */
export interface VolumeRequestBuilderGetQueryParameters {
    year?: number;
}
/**
 * Uri template for the request builder.
 */
export const VolumeRequestBuilderUriTemplate = "{+baseurl}/chargepoints/volume{?Year*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const VolumeRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "year": "Year",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const VolumeRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: VolumeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createChargePointVolumeFromDiscriminatorValue,
        queryParametersMapper: VolumeRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
